import React from "react";
import { Text, View } from "react-native";
import { COLOURS } from "../../../../constants";
import { useStylesUtils } from "../../../../hooks/useStylesUtils";
import RenderHtml from "react-native-render-html";

export const HomeWorksDescription = ({ title }) => {
    const { styles, width } = useStylesUtils(getStyles);

    const source = {
        html: `${title}`,
    };
    if (title) {
        return (
            <View style={{ flex: 1, alignItems: "center" }}>
                <Text style={styles.text}>
                    <RenderHtml
                        contentWidth={width}
                        source={source}
                        style={styles.text}
                    />
                </Text>
            </View>
        );
    }
    return <></>;
};

const getStyles = {
    text: {
        textAlign: "center",
        fontSize: 16,
        fontWeight: 600,
        color: COLOURS.dark_purple,
    },
};
